module.exports = ".border{\r\n    border: 1px solid gray;\r\n    border-radius: 3px;\r\n    padding: 10px 15px;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.form-row{\r\n    border-bottom: 1px solid #cac8c8;\r\n    margin: 5px 0px 15px 0px;;\r\n}\r\n.form-row:nth-last-child(1) {\r\n    border-bottom: none;\r\n    margin-bottom: -8px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/user/profile/profile.component.css
// module id = ./src/app/Pages/user/profile/profile.component.css
// module chunks = main